$(function(){

	console.log('%c Rich Cronin', 'font-size: 24px; color: #455CE9');
	console.log('%c richcronin.co.uk', 'font-size: 12px; color: #455CE9');

	const body 				= $('body');
	const header 			= $('.theme-header');
	const footer 			= $('.site-footer');
	const tablet_breakpoint = 990;
	const mobile_breakpoint = 768;
	const urlParams = new URLSearchParams(window.location.search);

    function matchHeights(selector) {
	  var maxHeight = 0;

	  $(selector).css('height', 'auto');

	  $(selector).each(function () {
	    var h = $(this).outerHeight();
	    if (h > maxHeight) {
	      maxHeight = h;
	    }
	  });

	  $(selector).height(maxHeight);
	}

	$(window).on('scroll', function () {
		if ($(window).scrollTop() > 100) {
			body.addClass('scrolled');
		} else {
			body.removeClass('scrolled');
		}
	});


	$(document).on('click', '[data-back-to-top]', function(e) {
	  e.preventDefault();

	  $('html, body').animate({
	    scrollTop: 0
	  }, 600);
	});

	$(document).on('click', '.theme-footer__footer [data-device-accordion]', function () {

		$(this).parent().toggleClass('expanded');

	});

	$(document).on('click', '[data-toggle-search]', function(e) {

		e.preventDefault();
		body.toggleClass('search-expanded');

	});

	$(document).on('click', '[data-clear-predictive-search]', function() {

		$('.search-modal .pred-search-form input').val('').trigger('input');

	});

	

	if ($(window).width() < tablet_breakpoint) {

		$(document).on('click', '[data-menu-item-toggle]', function(e) {

			e.preventDefault();
			$(this).parent().toggleClass('expanded');

		});

		$(document).on('click', '[data-toggle-level-3]', function(e) {

			e.preventDefault();
			$(this).parent().toggleClass('expanded');

		});

		$(document).on('click', '[data-toggle-menu]', function(e) {

			e.preventDefault();
			body.toggleClass('menu-drawer-expanded');

		});
	
	}

	  const $form = $('.pred-search-form');
	  const $input = $form.find('input[name="q"]');
	  const $container = $('.search-results-container');

	  const SECTION_ID = 'predictive-search-results';
	  const LIMIT = 8;
	  const DEBOUNCE_MS = 200;

	  let t;
	  let xhr;

		function fetchSuggest(q) {
		  return $.ajax({
		    url: '/search/suggest',
		    method: 'GET',
		    dataType: 'html',
		    data: {
		      q,
		      section_id: SECTION_ID,
		      'resources[type]': 'product',
		      'resources[limit]': LIMIT,
		      'resources[options][unavailable_products]': 'hide'
		    }
		  });
		}

		function fetchSkuFallback(q) {
		  return $.ajax({
		    url: '/search',
		    method: 'GET',
		    dataType: 'html',
		    data: {
		      q: q,
		      type: 'product',
		      view: 'predictive-sku'
		    }
		  });
		}

		function fetchResults(q) {
		  if (xhr) xhr.abort();

		  xhr = fetchSuggest(q).done(function (html) {
		    $container.html(html).show();

		    // if no items, fallback to SKU search
		    const hasResults = $container.find('.predictive-search__item').length > 0;
		    if (!hasResults) {
		      xhr = fetchSkuFallback(q).done(function (html2) {
		        $container.html(html2).show();
		      });
		    }
		  }).fail(function (err) {
		    if (err && err.statusText === 'abort') return;
		    $container.empty().hide();
		  });
		}


	  $input.on('input', function () {
	    clearTimeout(t);

	    const q = ($input.val() || '').trim();
	    if (q.length < 2) {
	      if (xhr) xhr.abort();
	      $container.empty().hide();
	      return;
	    }

	    t = setTimeout(() => fetchResults(q), DEBOUNCE_MS);
	  });


	function rerenderCartDrawer() {
	  return $.get('/?sections=cart-drawer', function (res) {
	    const sections = typeof res === 'string' ? JSON.parse(res) : res;

	    const drawerHtml = sections['cart-drawer'];
	    const updatedCart = $(drawerHtml).find('#cart-rerender').html();

	    $('#cart-rerender').html(updatedCart);

	    setTimeout(function(){
		    console.log($('.cart-output .item').length);
	      	if ($('.cart-output .item').length === 0) {
	      		console.log('reached');
				$('#cart-rerender').addClass('no-items');
			}
		}, 500);

	  });
	}

	$(document).on('click', '[data-add-to-cart]', function (e) {
		
		e.preventDefault();

		  const vid = $(this).data('vid');
		  if (!vid) return;
		  console.log(vid);

		  $.ajax({
		    type: 'POST',
		    url: '/cart/add.js',
		    data: { id: vid, quantity: 1 },
		    dataType: 'json',
		    success: function (item) {
		      body.addClass('cart-expand');
		      $('#cart-rerender').removeClass('no-items');
		      rerenderCartDrawer();
		    },
		    error: function (err) {
		      console.error('Add to cart failed:', err);
		    }
		  });
		
	});

	$(document).on('click', '[data-toggle-cart]', function (e) {
		
		e.preventDefault();
		body.toggleClass('cart-expand');

	});

	$(document).on('click', '.cart-drawer', function (e) {
	  	if ($(e.target).closest('.drawer').length) return;
	  	body.removeClass('cart-expand');
	});

	function changeLineItemQty(lineKey, newQty) {
	  return $.ajax({
	    type: 'POST',
	    url: '/cart/change.js',
	    data: {
	      id: lineKey,       // IMPORTANT: for /cart/change.js, id can be the line item key
	      quantity: newQty
	    },
	    dataType: 'json'
	  });
	}

	$(document).on('click', '.cart-drawer [data-qty-plus]', function (e) {
	  e.preventDefault();

	  const $wrap = $(this).closest('.j-qty-selection');
	  const lineKey = $wrap.data('line-key');
	  const $input = $wrap.find('input[name="quantity"]');

	  const currentQty = parseInt($input.val(), 10) || 0;
	  const newQty = currentQty + 1;

	  changeLineItemQty(lineKey, newQty)
	    .done(() => rerenderCartDrawer())
	    .fail(err => console.error('Qty increase failed:', err));
	});

	$(document).on('click', '[data-qty-minus]', function (e) {
	  e.preventDefault();

	  const $wrap = $(this).closest('.j-qty-selection');
	  const lineKey = $wrap.data('line-key');
	  const $input = $wrap.find('input[name="quantity"]');

	  const currentQty = parseInt($input.val(), 10) || 0;
	  const newQty = Math.max(currentQty - 1, 0); // 0 = remove

	  changeLineItemQty(lineKey, newQty)
	    .done(() => rerenderCartDrawer())
	    .fail(err => console.error('Qty decrease failed:', err));
	});

	$(document).on('click', '.cart-remove-item', function (e) {
		  e.preventDefault();

		  const $btn = $(this);
		  const name = $btn.attr('name');
		  const matches = name.match(/updates\[(\d+):.*?\]/);
		  if (!matches || !matches[1]) return;

		  const lineItemId = matches[1];

		  $.ajax({
		    type: 'POST',
		    url: '/cart/change.js',
		    data: { id: lineItemId, quantity: 0 },
		    dataType: 'json',
		    success: function () { 
		      	rerenderCartDrawer();
		    },
		    error: function (err) {
		      	console.error('Remove failed:', err);
		    }
		});

	});

	$(document).on('click', '[data-toggle-cart-gift]', function(){

		$(this).parent().toggleClass('gift-messaging-expand');

	});

	$(document).on('change blur', '#cart-gift-message', function () {
	  $.ajax({
	    type: 'POST',
	    url: '/cart/update.js',
	    data: {
	      attributes: {
	        'Gift message': $(this).val()
	      }
	    },
	    dataType: 'json'
	  });
	});

	

	if (urlParams.get('cart') === 'true') {
		body.addClass('cart-expand');
	}
	  	

	



});